import Head from "next/head";
import * as S from "./Venue.styles";

export default function Venue() {
  return (
    <>
      <Head>
        <meta
          name="description"
          property="og:description"
          content="Details of the venue and location for Chloë and David's wedding"
        />
        <title>Venue &amp; Visit • David &amp; Chloë</title>
      </Head>

      <S.Container>
        <h2>Venue</h2>
        <p>
          The wedding will take place at the Majestic Hotel in Harrogate.
          Immediately next door is a Premier Inn and Crown Plaza. We recommend
          you stay in one of these locations.
          {/* If you would like to stay overnight in either hotel, you should inform them when booking that you are part of the Sint/Rose wedding group. */}
        </p>
        <p>
          <strong>
            Currently, rooms will only be ready from 16:00, so if your stay
            starts on Sunday you may not have time to check-in and will not be
            able to get into your room to change before the chuppah.
          </strong>
        </p>

        <S.Address>
          <a
            href="https://www.hilton.com/en/hotels/lbahadi-doubletree-harrogate-majestic-hotel-and-spa/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <h3>DoubleTree by Hilton Harrogate Majestic Hotel &amp; Spa</h3>
            <S.Img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/The_Majestic_Hotel%2C_Harrogate_25092017_Fuji_Finepix%2C_%2827%29_%2823543407618%29.jpg/557px-The_Majestic_Hotel%2C_Harrogate_25092017_Fuji_Finepix%2C_%2827%29_%2823543407618%29.jpg"
              alt="Back of the Majestic Hotel"
            />
          </a>
          <p>
            Harrogate HG1 2HU
            <br />
            +44 1423 700300
          </p>
          <a href="https://www.hilton.com/en/book/reservation/rooms/?ctyhocn=LBAHADI&arrivalDate=2022-09-03&departureDate=2022-09-05&room1NumAdults=1&brandCode=DT">
            Majestic room booking link
          </a>
        </S.Address>

        <h3>Parking</h3>
        <p>
          Hotel guests can get parking.{" "}
          <strong>
            Non-hotel guests must register their number plate at reception which
            will last for 8-hours of free parking.
          </strong>{" "}
          After 8 hours, you may have to re-register your number plate at
          reception.
        </p>

        <h2>Other Hotels</h2>
        <S.TwoByTwo>
          <S.Address>
            <a
              href="https://www.premierinn.com/gb/en/hotels/england/north-yorkshire/harrogate/harrogate-town-centre.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>Premier Inn Harrogate Town Centre hotel</h3>
              <S.Img
                src="https://www.premierinn.com/content/dam/pi/websites/hotelimages/gb/en/H/harspr/Harrogate%20TC004.jpg"
                alt="Side of the Premier Inn"
              />
            </a>
            <p>
              9 Springfield Ave, Harrogate HG1 2HY
              <br />
              +44 3333 219312
            </p>
            <a href="https://www.premierinn.com/gb/en/hotels/england/north-yorkshire/harrogate/harrogate-town-centre.html?ARRdd=03&ARRmm=09&ARRyyyy=2022&NIGHTS=2&ROOMS=1&ADULT1=1&CHILD1=0&COT1=0&INTTYP1=DB&BRAND=PI">
              Premier Inn room booking link
            </a>
          </S.Address>

          <S.Address>
            <a
              href="https://www.ihg.com/crowneplaza/hotels/gb/en/harrogate/hrtuk/hoteldetail"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>Crown Plaza, Harrogate</h3>
              <S.Img
                src="https://digital.ihg.com/is/image/ihg/crowne-plaza-harrogate-5140884899-4x3?wid=640&qlt=85,0&resMode=sharp2&op_usm=1.75,0.9,2,0"
                alt="Crown Plaza hotel infront of blue sky"
              />
            </a>
            <p>
              King&apos;s Rd, Harrogate HG1 1XX
              <br />
              +44 1423 849988
            </p>
          </S.Address>
        </S.TwoByTwo>

        <h2>Things to do</h2>
        <S.TwoByTwo>
          <S.Address>
            <a
              href="https://www.bettys.co.uk/cafe-tea-rooms/our-locations/bettys-harrogate"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>Bettys Café Tea Rooms</h3>
              <S.Img
                src="https://www.bettys.co.uk/media/media/cafe_tea_rooms/harrogate-main.jpg"
                alt="Signage of Betty's Harrogate"
              />
            </a>
            <p>
              1 Parliament Street, Harrogate HG1 2QU
              <br />
              +44 1423 814070
            </p>
          </S.Address>

          <S.Address>
            <a
              href="https://www.harrogate.gov.uk/pos/Pages/ValleyGardens.aspx"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>Valley Gardens Harrogate</h3>
              <S.Img
                src="https://s3.eu-west-2.amazonaws.com/dc-harrogate/business-directory/Extract-Valley-Gardens-HERO.jpg"
                alt="Valley Gardens in late summer"
              />
            </a>
            <p>
              Also contains a Model Boating Pond, Tennis Courts, Crazy Golf and
              Pitch and Putt Golf Course.
            </p>
            <p>
              Valley Drive, Harrogate HG1 2SZ
              <br />
              +44 1423 500600
            </p>
          </S.Address>
        </S.TwoByTwo>

        <S.TwoByTwo>
          <S.Address>
            <a
              href="https://www.rhs.org.uk/gardens/harlow-carr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>RHS Gardens Harlow Carr</h3>
              <S.Img
                src="https://assets.caboodlecrm.com/Content/Image/30278"
                alt="Harlow Carr pathway with blooming flowers"
              />
            </a>
            <p>
              Crag Lane, Harrogate HG3 1QB
              <br />
              +44 1423 565418
            </p>
          </S.Address>

          <S.Address>
            <a
              href="https://turkishbathsharrogate.co.uk/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>Turkish Baths Harrogate</h3>
              <S.Img
                src="https://www.yorkshire.com/media/66185/turkishsignaturespaimage.jpg"
                alt="Frontage of Turkish Baths"
              />
            </a>
            <p>
              Parliament Street, Harrogate HG1 2WH
              <br />
              +44 1423 556746
            </p>
          </S.Address>
        </S.TwoByTwo>

        <S.TwoByTwo>
          <S.Address>
            <a
              href="https://harewood.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>Harewood House</h3>
              <S.Img
                src="https://upload.wikimedia.org/wikipedia/commons/1/13/Harewood_House%2C_seen_from_the_garden.JPG"
                alt="Harewood House seen from the garden"
              />
            </a>
            <p>
              Harewood House, Leeds LS17 9LG
              <br />
              +44 1132 181010
            </p>
          </S.Address>

          <S.Address>
            <h3>Harrogate Shopping District</h3>
            <S.Img
              src="https://www.harrogateadvertiser.co.uk/webimg/QVNIMTIwNjY4NzAy.jpg"
              alt="Harewood House seen from the garden"
            />
            <p>
              Explore shopping around Cambridge Street and James Street with
              shops including Lakeland, Mint Velvet, Jo Malone, as well as
              unique arts and antiques shops.
            </p>
          </S.Address>
        </S.TwoByTwo>

        <h2>Towns to visit</h2>
        <S.TwoByTwo>
          <S.Address>
            <a
              href="https://www.visitharrogate.co.uk/in-the-area/knaresborough"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>Knaresborough</h3>
              <S.Img
                src="https://s3.eu-west-2.amazonaws.com/dc-harrogate/miscellaneous/Header-Knaresborough-Charlotte-Gale.jpg"
                alt="Knaresborough Bridge"
              />
            </a>
            <p>
              A Market and spa town with a castle, Mother Shipton’s Cave,
              railway viaduct, and market.
            </p>
          </S.Address>

          <S.Address>
            <a
              href="https://www.tripadvisor.co.uk/Attractions-g186346-Activities-York_North_Yorkshire_England.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3>York</h3>
              <S.Img
                src="https://www.visitbritain.com/sites/default/files/styles/consumer_campaigns_hero_mobile/public/paragraphs_bundles/hero/york_0.jpg?itok=r4IkB8HI"
                alt="Little Shambles Street in York"
              />
            </a>
            <p>
              Roman roots and a Viking past, York is the head city of historic
              Yorkshire and has museums, castles, and cultural sites (🍻).
            </p>
          </S.Address>
        </S.TwoByTwo>

        <S.Address>
          <a
            href="https://www.yorkshiredales.org.uk/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <h3>Yorkshire Dales</h3>
            <S.Img
              src="https://upload.wikimedia.org/wikipedia/commons/1/13/2015_Swaledale_from_Kisdon_Hill.jpg"
              alt="View into Swaledale (to the south-east) from the Pennine Way along Kisdon hill"
            />
          </a>
          <p>
            River valleys and hills, the Dales are close to Harrogate with many
            beautiful villages and walks to explore.
          </p>
        </S.Address>
      </S.Container>
    </>
  );
}
